import {
  CHANGE_EMAIL,
  CHANGE_EMAIL_FAILURE,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_EMAIL_VALIDATION_FAILURE,
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_MOBILE_NUMBER,
  CHANGE_MOBILE_NUMBER_FAILURE,
  CHANGE_MOBILE_NUMBER_SUCCESS,
  CHANGE_MOBILE_NUMBER_VALIDATION_FAILURE,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_VALIDATION_FAILURE,
  CHANGE_STEP,
  CHOOSE_DOCUMENT,
  CHOOSE_DOCUMENT_CANCELLATION,
  CHOOSE_DOCUMENT_FAILURE,
  CHOOSE_DOCUMENT_SUCCESS,
  CLOSE_MODAL_STATE,
  FETCH_LEGAL_NAME_MILITARY_STATUS,
  FETCH_LEGAL_NAME_MILITARY_STATUS_FAILURE,
  FETCH_LEGAL_NAME_MILITARY_STATUS_SUCCESS,
  FETCH_MOBILE_NUMBER_STATUS,
  FETCH_MOBILE_NUMBER_STATUS_FAILURE,
  FETCH_MOBILE_NUMBER_STATUS_SUCCESS,
  FETCH_PROFILE,
  FETCH_PROFILE_FAILURE,
  FETCH_PROFILE_SUCCESS,
  INPUT_ERRORS,
  OPEN_MODAL_STATE,
  PROCESS_DOCUMENT,
  PROCESS_DOCUMENT_FAILURE,
  PROCESS_DOCUMENT_SUCCESS,
  RESET_BANNER_ERROR,
  RESET_ERRORS_STATE,
  RESET_FORM_ERRORS_STATE,
  RESET_FORM_STATE,
  RESET_REQUEST_STATUS_STATE,
  RESET_STEP_STATE,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_DOCUMENT_SUCCESS,
  VERIFY_MOBILE_NUMBER,
  VERIFY_MOBILE_NUMBER_FAILURE,
  VERIFY_MOBILE_NUMBER_SUCCESS,
  VERIFY_MOBILE_NUMBER_VALIDATION_FAILURE,
} from './constants';

export function changeInput({
  field,
  form,
  nestedField,
  value,
}) {
  return {
    payload: {
      field,
      form,
      nestedField,
      value,
    },
    type: CHANGE_INPUT,
  };
}

export function changeInputError({
  field,
  form,
  value,
}) {
  return {
    payload: {
      field,
      form,
      value,
    },
    type: CHANGE_INPUT_ERROR,
  };
}

export function changeEmail({ newEmail }) {
  return {
    payload: { newEmail },
    type: CHANGE_EMAIL,
  };
}

export function changeEmailFailure(error) {
  return {
    payload: { error },
    type: CHANGE_EMAIL_FAILURE,
  };
}

export function changeEmailSuccess(currentSetting) {
  return {
    payload: { currentSetting },
    type: CHANGE_EMAIL_SUCCESS,
  };
}

export function changeEmailValidationFailure(error) {
  return {
    payload: { error },
    type: CHANGE_EMAIL_VALIDATION_FAILURE,
  };
}

export function changeMobileNumber({ isVerify, mobileNumber }) {
  return {
    payload: { isVerify, mobileNumber },
    type: CHANGE_MOBILE_NUMBER,
  };
}

export function changeMobileNumberFailure(error) {
  return {
    payload: { error },
    type: CHANGE_MOBILE_NUMBER_FAILURE,
  };
}

export function changeMobileNumberSuccess({ currentSetting, message }) {
  return {
    payload: { currentSetting, message },
    type: CHANGE_MOBILE_NUMBER_SUCCESS,
  };
}

export function changeMobileNumberValidationFailure(error) {
  return {
    payload: { error },
    type: CHANGE_MOBILE_NUMBER_VALIDATION_FAILURE,
  };
}

export function changePassword({ newPassword, oldPassword }) {
  return {
    payload: { newPassword, oldPassword },
    type: CHANGE_PASSWORD,
  };
}

export function changePasswordFailure() {
  return { type: CHANGE_PASSWORD_FAILURE };
}

export function changePasswordSuccess() {
  return { type: CHANGE_PASSWORD_SUCCESS };
}

export function changePasswordValidationFailure({ field, message }) {
  return {
    payload: { field, message },
    type: CHANGE_PASSWORD_VALIDATION_FAILURE,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function chooseDocument({ reviewScreenName, type }) {
  return {
    payload: { reviewScreenName, type },
    type: CHOOSE_DOCUMENT,
  };
}

export function chooseDocumentCancellation() {
  return { type: CHOOSE_DOCUMENT_CANCELLATION };
}

export function chooseDocumentFailure({ bannerError }) {
  return {
    payload: { bannerError },
    type: CHOOSE_DOCUMENT_FAILURE,
  };
}

export function chooseDocumentSuccess() {
  return { type: CHOOSE_DOCUMENT_SUCCESS };
}

export function closeModalState() {
  return { type: CLOSE_MODAL_STATE };
}

export function fetchLegalNameMilitaryStatus() {
  return { type: FETCH_LEGAL_NAME_MILITARY_STATUS };
}

export function fetchLegalNameMilitaryStatusFailure(error) {
  return {
    payload: { error },
    type: FETCH_LEGAL_NAME_MILITARY_STATUS_FAILURE,
  };
}

export function fetchLegalNameMilitaryStatusSuccess({ legalName, militaryServiceStatus }) {
  return {
    payload: { legalName, militaryServiceStatus },
    type: FETCH_LEGAL_NAME_MILITARY_STATUS_SUCCESS,
  };
}

export function fetchMobileNumberStatus() {
  return { type: FETCH_MOBILE_NUMBER_STATUS };
}

export function fetchMobileNumberStatusFailure(error) {
  return {
    payload: { error },
    type: FETCH_MOBILE_NUMBER_STATUS_FAILURE,
  };
}

export function fetchMobileNumberStatusSuccess({ allowedOperation, currentSetting, status }) {
  return {
    payload: { allowedOperation, currentSetting, status },
    type: FETCH_MOBILE_NUMBER_STATUS_SUCCESS,
  };
}

export function fetchProfile() {
  return { type: FETCH_PROFILE };
}

export function fetchProfileFailure(error) {
  return {
    payload: { error },
    type: FETCH_PROFILE_FAILURE,
  };
}

export function fetchProfileSuccess(currentSetting) {
  return {
    payload: { currentSetting },
    type: FETCH_PROFILE_SUCCESS,
  };
}

export function inputErrors({ form, formErrors }) {
  return {
    payload: { form, formErrors },
    type: INPUT_ERRORS,
  };
}

export function openModalState({ modalState }) {
  return {
    payload: { modalState },
    type: OPEN_MODAL_STATE,
  };
}

export function processDocument({ file, mobile }) {
  return {
    payload: { file, mobile },
    type: PROCESS_DOCUMENT,
  };
}

export function processDocumentFailure({ bannerError, file, validationError } = {}) {
  return {
    payload: { bannerError, file, validationError },
    type: PROCESS_DOCUMENT_FAILURE,
  };
}

export function processDocumentSuccess({ file }) {
  return {
    payload: { file },
    type: PROCESS_DOCUMENT_SUCCESS,
  };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetErrorsState() {
  return { type: RESET_ERRORS_STATE };
}

export function resetFormErrorsState({ field, form }) {
  return {
    payload: { field, form },
    type: RESET_FORM_ERRORS_STATE,
  };
}

export function resetFormState({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_STATE,
  };
}

export function resetRequestStatusState({ state }) {
  return {
    payload: { state },
    type: RESET_REQUEST_STATUS_STATE,
  };
}

export function resetStepState() {
  return { type: RESET_STEP_STATE };
}

export function uploadDocument({
  document,
  documentCategory,
  documentName,
  documentSize,
}) {
  return {
    payload: {
      document,
      documentCategory,
      documentName,
      documentSize,
    },
    type: UPLOAD_DOCUMENT,
  };
}

export function uploadDocumentFailure({ bannerError, isMobile, validationError } = {}) {
  return {
    payload: { bannerError, isMobile, validationError },
    type: UPLOAD_DOCUMENT_FAILURE,
  };
}

export function uploadDocumentSuccess({ isMobile }) {
  return {
    payload: { isMobile },
    type: UPLOAD_DOCUMENT_SUCCESS,
  };
}

export function verifyMobileNumber({ mobileNumber, passCode, token }) {
  return {
    payload: { mobileNumber, passCode, token },
    type: VERIFY_MOBILE_NUMBER,
  };
}

export function verifyMobileNumberFailure(error) {
  return {
    payload: { error },
    type: VERIFY_MOBILE_NUMBER_FAILURE,
  };
}

export function verifyMobileNumberSuccess({ currentSetting, message }) {
  return {
    payload: { currentSetting, message },
    type: VERIFY_MOBILE_NUMBER_SUCCESS,
  };
}

export function verifyMobileNumberValidationFailure(error) {
  return {
    payload: { error },
    type: VERIFY_MOBILE_NUMBER_VALIDATION_FAILURE,
  };
}
